export const IMAGER_APP_ID = '73d01f92-aeb8-4f75-868a-223285a19ea7';

export function passwordLoginUrl(appID, appVars, serverUrl = '') {
  if (appID !== IMAGER_APP_ID) return appVars.loginRedirect || appVars.lightwerksUrl || appVars.companyUrl || '';
  const fallback = 'https://imager.digitalwerks.com/login';
  try {
    const url = new URL(serverUrl);
    if (url.origin !== 'https://imager.digitalwerks.com' || url.pathname !== '/login' || url.username || url.password) return fallback;
    const intent = url.searchParams.get('intent');
    return ['personalized_image', 'countdown_timer'].includes(intent) ? `${fallback}?intent=${intent}` : fallback;
  } catch (_) { return fallback; }
}
